import utils from '@cob/ui-genesis/cob.utils.js';

//Helper Model to hold field errors info
var FieldErrorM = function(core) {
    this._core = core;
    this._errors = [];
};

FieldErrorM = function(core, errors) {
    this._core = core;
    this._errors = errors || [];
};

FieldErrorM.prototype.addError = function(field, errorType, uri) {
    this._errors.push({field: field, errorType: errorType, uri: uri});
};

//returns an array of ready to use error messages[ {field: ...., errorMsg: ...}, {}..]
FieldErrorM.prototype.getTranslatedErrors = function() {
    return this._errors.map(function(err) {
        var newErr = {},
            fieldName,
            hasIdAndName,
            firstTwoDotsIdx,
            maxLen;

        utils.extend(newErr, err, true);

        if(err.error){
            hasIdAndName = err.error.lastIndexOf(":") > err.error.indexOf(":");
            firstTwoDotsIdx = hasIdAndName
                              ? err.error.indexOf(":")
                              : -1;

            fieldName = err.error.substring(firstTwoDotsIdx + 1, err.error.lastIndexOf(":"));

            if(hasIdAndName){
                newErr.fieldId = err.error.substring(0, firstTwoDotsIdx);
            }

            maxLen = (fieldName == "name" ? 40 : 255);

            newErr.errorMsg = (this._core.translateString("field-error", newErr.errorType) || newErr.errorType)
                .replace("__LENGTH__", maxLen);
        }

        return newErr;
    }.bind(this));
};

FieldErrorM.prototype.hasErrors = function() {
    return this._errors.length > 0;
};

export default FieldErrorM;
